import React, { useState, useEffect } from 'react';
import { Task } from '../types';
import api from '../api/client';
import Navbar from '../components/Navbar';
import './Tasks.css';

const Tasks: React.FC = () => {
  const [tasks, setTasks] = useState<Task[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      setUser(JSON.parse(userStr));
    }
    loadTasks();
  }, []);

  const loadTasks = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await api.get('/api/tasks');
      if (response.data.success) {
        setTasks(response.data.data || []);
      } else {
        setError(response.data.error?.message || 'Ошибка загрузки задач');
      }
    } catch (err: any) {
      console.error('Ошибка загрузки задач:', err);
      setError(err.response?.data?.error?.message || 'Ошибка загрузки задач');
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'done': return '#10b981';
      case 'in_progress': return '#f59e0b';
      case 'pending': return '#6b7280';
      case 'cancelled': return '#ef4444';
      default: return '#3b82f6';
    }
  };

  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'urgent': return '#ef4444';
      case 'high': return '#f59e0b';
      case 'medium': return '#3b82f6';
      case 'low': return '#6b7280';
      default: return '#6b7280';
    }
  };

  return (
    <div className="tasks-page">
      {user && <Navbar user={user} />}
      <main className="tasks-main">
        <div className="tasks-header">
          <h1>Задачи</h1>
          <button className="tasks-refresh" onClick={loadTasks}>
            Обновить
          </button>
        </div>

        {loading && <div className="tasks-loading">Загрузка...</div>}

        {error && (
          <div className="tasks-error">
            <p>{error}</p>
            <button onClick={loadTasks}>Попробовать снова</button>
          </div>
        )}

        {!loading && !error && tasks.length === 0 && (
          <div className="tasks-empty">
            <p>Нет задач</p>
          </div>
        )}

        {!loading && tasks.length > 0 && (
          <div className="tasks-grid">
            {tasks.map((task) => (
              <div key={task.id} className="task-card">
                <div className="task-card-header">
                  <span
                    className="task-status"
                    style={{ backgroundColor: getStatusColor(task.status) }}
                  >
                    {task.status === 'done' ? 'Выполнено' :
                     task.status === 'in_progress' ? 'В работе' :
                     task.status === 'pending' ? 'Ожидает' :
                     task.status === 'cancelled' ? 'Отменено' : task.status}
                  </span>
                  <span
                    className="task-priority"
                    style={{ color: getPriorityColor(task.priority) }}
                  >
                    {task.priority === 'urgent' ? 'Срочно' :
                     task.priority === 'high' ? 'Высокий' :
                     task.priority === 'medium' ? 'Средний' :
                     task.priority === 'low' ? 'Низкий' : task.priority}
                  </span>
                </div>
                <h3 className="task-title">{task.title}</h3>
                {task.description && (
                  <p className="task-description">{task.description}</p>
                )}
                <div className="task-footer">
                  {task.assignee_name && (
                    <span className="task-assignee">Исполнитель: {task.assignee_name}</span>
                  )}
                  {task.due_date && (
                    <span className="task-due">Срок: {new Date(task.due_date).toLocaleDateString()}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default Tasks;